module.exports = __webpack_public_path__ + "static/media/defaultAvatar.9f5bf8e4.png";